var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1175 140H11.6667C5.22667 140 0 134.773 0 128.333V11.6667C0 5.22667 5.22667 0 11.6667 0H93.3333C99.7733 0 105 5.22667 105 11.6667V35H93.3333V17.5H11.6667V116.667H75.8333V131.25C75.8333 134.307 76.895 138.104 79.1175 140ZM131.25 40.8333C136.08 40.8333 140 44.7533 140 49.5833V131.25C140 136.068 136.086 140 131.25 140H90.4167C85.5808 140 81.6667 136.062 81.6667 131.25V49.5833C81.6667 44.7592 85.5925 40.8333 90.4167 40.8333H131.25ZM52.5 122.5C55.72 122.5 58.3333 125.113 58.3333 128.333C58.3333 131.553 55.72 134.167 52.5 134.167C49.28 134.167 46.6667 131.553 46.6667 128.333C46.6667 125.113 49.28 122.5 52.5 122.5ZM110.833 134.167C107.608 134.167 105 131.553 105 128.333C105 125.113 107.608 122.5 110.833 122.5C114.053 122.5 116.661 125.113 116.661 128.333C116.661 131.553 114.053 134.167 110.833 134.167ZM134.167 116.667V58.1933H87.5V116.667H134.167ZM113.75 52.5C115.354 52.5 116.667 51.1933 116.667 49.5833C116.667 47.9733 115.354 46.6667 113.75 46.6667H107.917C106.307 46.6667 105 47.9733 105 49.5833C105 51.1933 106.307 52.5 107.917 52.5H113.75Z",
    fill: "#1C3472"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobileApp.b53f35f91b0e0c077e36d08c8942e389.svg";
export { ForwardRef as ReactComponent };